export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "角色ID", prop: "id", width: 80 },
    { label: "角色名称", prop: "title" },
    { label: "账号状态", prop: "status", slots: 'status' },
    // { label: "菜单权限", prop: "rules" },
    // {
    //   label: "创建时间",
    //   prop: "create_time",
    //   width: 180,
    // },
    {
      label: "操作",
      prop: "operation",
      width: 200,
      slots: "operation",
      fixed: "right",
    },
  ];
}
